// Expand a collapsed newsletter form (see forms.css) as soon as the visitor
// starts entering their e-mail address.
//
// Deliberately keyed on "input", not on "focus" and not on a "continue" button:
// focus also happens while tabbing through the document, and hiding the rest
// behind a button -- only to then ask for a name and newsletter choices -- comes
// across as sneaky. Typing an address is the point where the visitor has
// actually decided to subscribe.
//
// Delegated on the body because the form is loaded and re-rendered by htmx.
export function initNewsletterForm() {
  document.body.addEventListener("input", (e) => {
    const form = e.target?.closest(".newsletter.-compact .newsletter-form")
    if (form) form.classList.add("-expanded")
  })
}
